import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useSliderContext } from '../../../../utils/sliderContext';
export var AutoScrollController = function AutoScrollController(_ref) {
  var _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 1000 : _ref$interval;

  var _useSliderContext = useSliderContext(),
      scrollNext = _useSliderContext.scrollNext,
      currentSlide = _useSliderContext.currentSlide,
      totalSlides = _useSliderContext.totalSlides;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      timer = _React$useState2[0],
      setTimer = _React$useState2[1];

  var lastAutoscrollSlide = React.useRef(currentSlide); // Запускает таймер с автопрокрутой слайдов

  React.useEffect(function () {
    var scrollTimer = setInterval(function () {
      scrollNext();
      lastAutoscrollSlide.current += 1;
    }, interval);
    setTimer(scrollTimer);
    return function () {
      if (scrollTimer) {
        clearInterval(scrollTimer);
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Останавливает таймер с автопрокруткой слайдов по условиям

  React.useEffect(function () {
    if (!timer) {
      return;
    }

    var isLastSlide = currentSlide === totalSlides - 1;
    /**
     * Флаг означает, что пользователь вручную прокрутил слайд
     *
     * Вычисляем с помощью сравнения счетчика слайдов, которые были прокручены автоматически lastAutoscrollSlide
     * с текущим счетчиком слайдов currentSlide
     */

    var isStoppedByUser = currentSlide > 0 && currentSlide !== lastAutoscrollSlide.current;

    if (isLastSlide || isStoppedByUser) {
      clearInterval(timer);
      setTimer(null);
    }
  }, [currentSlide, scrollNext, timer, totalSlides]);
  React.useEffect(function () {
    return function () {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [timer]);
  return null;
};